import type { ReactElement, ReactNode } from "react"
import ImageLinkAtm from "@onestore/hel/dist/components/atoms/ImageLinkAtm"
import FormilyFormButton from "@gatsby-plugin-generic-page/components/FormilyFormButton"
import type { Formily as FormilyType } from "@gatsby-plugin-generic-page/fragments/formily"
import { SquidexFormType } from "@gatsby-plugin-generic-page/types/formType"
import { typeMatches } from "@onestore-graphql"
import type { Forms } from "~/types/squidex"

interface Props {
  image: ReactNode
  title: string
  form: Forms[]
}

function ImageFormButton({
  image,
  title,
  form,
}: Props): ReactElement<Props> | null {
  const { __typename } = form[0]

  if (!typeMatches(__typename, SquidexFormType.FORMILY_FORM)) {
    return null
  }

  return (
    <FormilyFormButton
      button={(onClick) => (
        <ImageLinkAtm image={image} title={title} onClick={onClick} />
      )}
      formilyForm={form[0] as FormilyType}
    />
  )
}

export default ImageFormButton
